export const SET_DEMO_MODE = 'demo-mode/SET';

export const setDemoMode = payload => dispatch => {
  dispatch({ type: SET_DEMO_MODE, payload });
  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./app/actions/set-demo-mode.js